module.exports = __webpack_public_path__ + "images/illustrations/illustration-high5-clouds-8afc3d160db42b008952681eaa6f174d.webp";